module.exports = __webpack_public_path__ + "media/assets/images/conference_room_forms/u-form-ca2a8a6aa3aa43540ec6b7915f50e48c.gif";